"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteCell = void 0;
const react_1 = require("react");
const inline_table_field_cells_1 = require("../../../components/inline-table-field/inline-table-field-cells");
function AutocompleteCell(props) {
    return function useCell({ collectionDatakey, ...inlineProps }) {
        const AutocompleteCell = inline_table_field_cells_1.InlineTableFieldCells.useInlineAutocompleteCellFactory({
            ...props,
            ...inlineProps,
            collectionDatakey,
        });
        return (0, react_1.useMemo)(() => AutocompleteCell, [collectionDatakey]);
    };
}
exports.AutocompleteCell = AutocompleteCell;
//# sourceMappingURL=autocomplete-cell.js.map